import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ClipboardDocumentCheckIcon,
  AdjustmentsHorizontalIcon,
  ArrowPathRoundedSquareIcon,
  ScaleIcon,
} from '@heroicons/react/24/outline';
import { PublicLayout } from '../components/layouts';
import { Seo } from '../seo/Seo';
import {
  DeckHero,
  DeckSection,
  DeckSectionHeader,
  DeckPillarGrid,
  DeckFinalCta,
  useDeckAnimateOnScroll,
} from '../components/landing/deck';

const About: React.FC = () => {
  const { t } = useTranslation(['about', 'common']);
  useDeckAnimateOnScroll();

  const values = [
    { key: 'innovation', icon: ClipboardDocumentCheckIcon },
    { key: 'accessibility', icon: AdjustmentsHorizontalIcon },
    { key: 'trust', icon: ArrowPathRoundedSquareIcon },
    { key: 'efficiency', icon: ScaleIcon },
  ] as const;

  return (
    <PublicLayout transparentHeader>
      <Seo route="/about" />

      <DeckHero
        title={t('about:hero.title')}
        subtitle={t('about:hero.subtitle')}
        primaryCta={{ label: t('about:cta.getStarted'), to: '/contact' }}
        secondaryCta={{ label: t('about:cta.contactUs'), to: '/compliance' }}
      />

      <DeckSection>
        <DeckSectionHeader
          badge={t('about:mission.eyebrow')}
          title={t('about:mission.headline')}
        />
        <div className="max-w-3xl space-y-6 animate-on-scroll">
          <p className="text-lg text-white/60 leading-relaxed">{t('about:mission.body1')}</p>
          <p className="text-lg text-white/60 leading-relaxed">{t('about:mission.body2')}</p>
        </div>
      </DeckSection>

      <DeckSection>
        <DeckSectionHeader
          badge={t('about:values.eyebrow')}
          title={t('about:values.headline')}
        />
        <DeckPillarGrid
          columns={4}
          pillars={values.map(({ key, icon }) => ({
            icon,
            tone: 'sky',
            title: t(`about:values.${key}.title`),
            description: t(`about:values.${key}.description`),
          }))}
        />
      </DeckSection>

      <DeckSection>
        <DeckSectionHeader
          badge={t('about:latam.eyebrow')}
          title={t('about:latam.headline')}
        />
        <div className="max-w-3xl space-y-6 animate-on-scroll">
          <p className="text-lg text-white/60 leading-relaxed">{t('about:latam.body1')}</p>
          <p className="text-lg text-white/60 leading-relaxed">{t('about:latam.body2')}</p>
        </div>
      </DeckSection>

      <DeckFinalCta
        title={t('about:cta.title')}
        subtitle={t('about:cta.subtitle')}
        email="ventas@callcov.com"
        cta={{ label: t('about:cta.getStarted'), to: '/contact' }}
      />
    </PublicLayout>
  );
};

export default About;
